"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Chip } from './Chip.web.js';
import { Box } from '../Box/Box.web.js';
import { IconCross } from '../icons/ui_control/IconCross.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { spacingNumerical } from '../constants/spacing.js';
import { inPixels } from '../utils/helpers/style.js';

var _excluded = ["items", "backgroundColor", "onChange", "focusFallback"];
var ChipList = function ChipList(props) {
  var containerRef = React.useRef(null);
  var items = props.items,
    backgroundColor = props.backgroundColor,
    onChange = props.onChange,
    focusFallback = props.focusFallback,
    rest = _objectWithoutProperties(props, _excluded);
  var handleChange = React.useCallback(function (value) {
    var containerElement = containerRef.current;
    if (containerElement) {
      var active = document.activeElement;
      var chips = Array.from(containerElement.children);
      var clickedChip = chips.find(function (element) {
        return element.contains(active) || element === active;
      });
      if (clickedChip) {
        var indexOfClickedButton = chips.indexOf(clickedChip);
        var fallbackElement = focusFallback ? focusFallback instanceof HTMLElement ? focusFallback : focusFallback.current : null;
        var nextButton = chips[indexOfClickedButton - 1] || chips[indexOfClickedButton + 1] ||
        // istanbul ignore next
        fallbackElement;

        // istanbul ignore next
        nextButton === null || nextButton === undefined || nextButton.focus();
      }
    }
    var itemValues = items.map(function (item) {
      return item.value;
    });
    var updated = itemValues.filter(function (prev) {
      return prev !== value;
    });
    onChange(updated);
  }, [items, onChange, focusFallback]);
  var theme = useTheme();
  var chipsTheme = theme.chips.web;
  var halfSpacingValue = spacingNumerical.xxxs / 2;
  var wrapperMargin = inPixels(-halfSpacingValue);
  var childMargin = inPixels(halfSpacingValue);
  return /*#__PURE__*/React.createElement(Box, _extends({
    boxRef: containerRef,
    "data-testid": "elemental-Chips",
    display: "flex",
    flexWrap: "wrap",
    role: "group",
    mh: wrapperMargin,
    mv: wrapperMargin
  }, rest), items.map(function (item) {
    return /*#__PURE__*/React.createElement(Chip, {
      key: item.value,
      label: typeof item.label === 'string' ? item.label : item.name,
      value: item.value,
      active: true,
      "aria-checked": true,
      role: "checkbox",
      color: backgroundColor ? backgroundColor : chipsTheme.color,
      onClick: handleChange,
      "data-testid": "elemental-ChipList-".concat(item.value),
      mh: childMargin,
      mv: childMargin,
      rightIcon: /*#__PURE__*/React.createElement(IconCross, null)
    });
  }));
};

export { ChipList };
